import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';

import {Carousel, Pagination} from 'antd';

import {get} from '../../api';

import guangqiImg from '../../assets/imgs/光启学词.jpg';
import haoyunbaImg from '../../assets/imgs/好运吧.jpg';
import qinfengImg from '../../assets/imgs/晴风预报.jpg';

import './index.scss';

export default function Ask() {
    const [articleData, setArticleData] = useState({});

    const getArticleData = (page = 1, pageSize = 10) => {
        get('/getList', {page, size: pageSize}).then(res => {
            if (res.code === 200) {
                setArticleData(res.data);
            }
        });
    };

    useEffect(() => {
        getArticleData();
    }, []);

    const onPageChange = page => {
        getArticleData(page);
    };

    return (
        <div
            id="ask-pc"
            className="flex flex-col justify-center px-[8.3vw] pt-[20px]"
        >
            <div className="main-1 flex justify-center">
                <div className="max-w-[1200px] min-w-[480px] h-[300px] relative">
                    <Carousel dotPosition="right" autoplay>
                        {/*    <a href="./" target="_blank" rel="noopener noreferrer">
                            <img src={guangqiImg} alt="img" style={contentStyle} />
                        </a>
                        */}
                        <div>
                            <img
                                src={guangqiImg}
                                alt="img"
                            />
                        </div>

                        <div>
                            <img
                                src={haoyunbaImg}
                                alt="img"
                            />
                        </div>

                        <div>
                            <img
                                src={qinfengImg}
                                alt="img"
                            />
                        </div>
                    </Carousel>
                </div>
            </div>

            <div className="main-2 my-[24px]">
                {/* <div className="flex justify-between items-center">
                    <h1 className="text-[32px] font-bold">热门专题</h1>
                    <a
                        href="."
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-[12px] text-[#666666]"
                    >
                        更多专题...
                    </a>
                </div> */}

                <div className="box-container flex justify-around flex-wrap gap-[12px] mt-[24px]">
                    <div>外壳伪装</div>
                    <div>隐秘聊天</div>
                    <div>隐私保护</div>
                    <div>官方正版</div>
                </div>
            </div>

            <div className="main-3 my-[24px] border-b-[2px]">
                <div className="flex justify-between items-center">
                    <h1 className="text-[32px] font-bold">热门专题</h1>
                </div>

                <div className="box-container">
                    {articleData.data?.map(item => (
                        <div className="box flex" key={item.id}>
                            <Link to={`/ask/${item.id}`}>
                                <div
                                    className="img"
                                    style={{
                                        backgroundImage: `url(${item.images})`,
                                    }}
                                />
                            </Link>

                            <div className="text-box">
                                <Link to={`/ask/${item.id}`}>{item.title}</Link>

                                <div className="time-box">
                                    <span>{item.create_time}</span>

                                    {/* <div className="tag-box">
                                        <a
                                            href="./"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            私密聊天软件
                                        </a>
                                        <a
                                            href="./"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            伪装聊天
                                        </a>
                                    </div> */}
                                </div>

                                <p className="tips">
                                    <span>{item.descrition}</span>
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="flex justify-center mb-[24px]">
                <Pagination
                    current={articleData.current_page || 1}
                    total={articleData.total}
                    onChange={onPageChange}
                />
            </div>
        </div>
    );
}
